import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import wx from 'weixin-js-sdk';
import store from "./store";
import "amfe-flexible"; // 引入flexible
import { Button, Image, Cell, Notify, Toast } from "vant"; // 按需引入vant。不需要引入样式，需要在Babel.config进行配置
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole()
// Vue.prototype.vConsole = vConsole;
// 将所有 loading Toast 设置为背景不可点击 (2.2.10 版本开始支持)
// 将所有 loading Toast 的展示时长设置为 2000 毫秒
Toast.setDefaultOptions("loading", { forbidClick: true, duration: 0 });
Vue.use(Button)
  .use(Image)
  .use(Cell)
  .use(Notify)
  .use(Toast);

import enumObject from "@/utils/enum";
Vue.prototype.$enumObject = enumObject;
import "./icons"; // icon
import "./permission"; // permission control

import "@/utils/request";

// console.log(`run in ${process.env.NODE_ENV}`)
//设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  wx,
  render: h => h(App)
}).$mount("#app");
